import { API } from '../../../config'

export const updateAboutMe = (value, successCB, failedCB) => async dispatch => {
  API.POST('/profile/about-me', value).then((response) => {
    return successCB && successCB(response)
  })
  .catch((err) => {
    return failedCB && failedCB(err.error || err.message)
  })
}